import React from 'react'
import cx from 'classnames'
import { t } from 'ttag'
import { Checkbox } from 'components/shared/FormFields/common/Checkbox/Checkbox'
import tabStyles from '../../tabs/tabs.module.scss'

export const CandidateSelect = ({
  candidates,
  selectedCandidates,
  setSelectedCandidates,
  disabled = {},
}) => {
  const ref = React.useRef(null)

  const toggleSelected = id => () => {
    setSelectedCandidates({
      ...selectedCandidates,
      [id]: !selectedCandidates[id],
    })
  }

  return (
    <div className={tabStyles.candidateSelects}>
      {candidates.map((candidate, index) => {
        const isDisabled = disabled[candidate.id]

        return (
          <div
            className={cx(
              tabStyles.candidateSelect,
              index ? tabStyles.second : tabStyles.first,
            )}
            key={index}
          >
            <Checkbox
              value={isDisabled ? false : selectedCandidates[candidate.id]}
              onChange={toggleSelected(candidate.id)}
              ref={ref}
              isDisabled={isDisabled}
            />
            <div
              className={cx(
                tabStyles.label,
                index ? tabStyles.second : tabStyles.first,
                { [tabStyles.disabled]: isDisabled },
              )}
              onClick={toggleSelected(candidate.id)}
            >
              {candidate.name} {isDisabled ? `(${t`no data available`})` : ''}
            </div>
          </div>
        )
      })}
    </div>
  )
}
